import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: 'inside',
    },
    listLayout: 'column',
  },
  blockDesign: {},
  itemDesign: {},
  containerDesign: {},
};

export const timelineSlice = createSlice({
  name: 'timeline',
  initialState,
  reducers: {
    timelineStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign ?? {};

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent?.items ?? [],
        heading: {
          title: blockContent?.heading?.title ?? '',
          description: blockContent?.heading?.description ?? '',
          textAlign: blockContent?.heading?.textAlign ?? 'left',
          image: blockContent?.heading?.image ?? '',
          divider: blockContent?.heading?.divider ?? '',
          position: blockContent?.heading?.position || 'inside',
        },
        listLayout: blockContent?.listLayout || 'column',
      };
      state.blockDesign = blockDesign ?? {};
    },
    timelineClear: () => initialState,

    timelineUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    timelineUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    timelineUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    timelineUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
    timelineUpdateItemDesign: (state, action) => {
      state.itemDesign = action.payload;
    },
  },
});

export const { timelineStore, timelineClear, timelineUpdateIsLoading, timelineUpdateIsActive, timelineUpdateBlockContent, timelineUpdateBlockDesign, timelineUpdateItemDesign } =
  timelineSlice.actions;

export const selectTimelineIsLoading = (state) => state.timeline.isLoading;
export const selectTimelineId = (state) => state.timeline.id;
export const selectTimelineUID = (state) => state.timeline.uid;
export const selectTimelineSID = (state) => state.timeline.sid;
export const selectTimelineBlockContent = (state) => state.timeline.blockContent;
export const selectTimelineBlockDesign = (state) => state.timeline.blockDesign;
export const selectTimelineSortItems = createSelector([selectTimelineBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectTimelineItemDesign = (state) => state.timeline.itemDesign;
export const selectTimelineContainerDesign = (state) => state.timeline.containerDesign;

export default timelineSlice.reducer;
